var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntern(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.662,
    height: 30,
    fill: "#73a91b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-564 -811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5,0C55,0,55,0,55,27.5S55,55,27.5,55,0,55,0,27.5,0,0,27.5,0Z",
    transform: "translate(564 811)",
    fill: "#eaf2dd"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(575 824)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5,25.127a2.3,2.3,0,1,0,3.185-2.115v-5.8a4.789,4.789,0,0,0-9.568-.316c-.017,0-.017,5.088-.017,5.088a4.563,4.563,0,1,1-9.126,0V19.839c4.617-.531,8.242-5.268,8.242-11.017,0-3.765-1.548-6.214-4.6-7.308a1.846,1.846,0,1,0-.523,1.651c2.3.86,3.391,2.688,3.391,5.657,0,5.149-3.31,9.339-7.377,9.339S1.729,13.971,1.729,8.822c0-2.97,1.089-4.8,3.39-5.657A1.847,1.847,0,1,0,4.6,1.513C1.548,2.607,0,5.056,0,8.822c0,5.749,3.624,10.486,8.242,11.017v2.143a6.293,6.293,0,0,0,12.586,0V17.21a3.062,3.062,0,0,1,6.125,0v3.14a4.882,4.882,0,1,0,2.9.383l-.007,1.757a3.365,3.365,0,0,1,.328.286,3.351,3.351,0,0,1-2.379,5.71,3.347,3.347,0,0,1-.847-6.586V23A2.3,2.3,0,0,0,25.5,25.127",
    transform: "translate(0 0)",
    fill: "#73a91b"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntern);
export default __webpack_public_path__ + "static/media/Intern.40739af830701eb7f70ac36ec17e2c97.svg";
export { ForwardRef as ReactComponent };